import { Chess } from "chess.js";
import { applyUci } from "./game";
import type { GameReview, MoveReview } from "./review";

/** Keep the first learning opportunity and the largest losses, in game order. */
export function studyMoments(review: GameReview, color: "w" | "b"): MoveReview[] {
  const own = review.moves.filter((m) => m.color === color);
  const mistakes = own.filter((m) => ["inaccuracy", "mistake", "blunder"].includes(m.classification));
  if (!mistakes.length) return own.filter((m) => m.classification === "best").slice(0, 3).length
    ? own.filter((m) => m.classification === "best").slice(0, 3) : own.slice(0, 1);
  const strongest = [...mistakes].sort((a, b) => (b.moverWinBefore - b.moverWinAfter) - (a.moverWinBefore - a.moverWinAfter));
  return [...new Map([mistakes[0], ...strongest].map((m) => [m.ply, m])).values()].slice(0, 3).sort((a, b) => a.ply - b.ply);
}

export function moveLabel(move: Pick<MoveReview, "fenBefore" | "san">): string {
  const [, side, , , , n] = move.fenBefore.split(" ");
  return `${n}${side === "w" ? "." : "…"} ${move.san}`;
}

/** An engine line is checked move by move before it can drive the board. */
export function studyLine(move: MoveReview) {
  const chess = new Chess(move.fenBefore);
  const line = move.before.pv.length ? move.before.pv : move.before.best ? [move.before.best] : [];
  const positions = [{ fen: chess.fen(), san: "Position", uci: "" }];
  for (const uci of line.slice(0, 8)) {
    const played = applyUci(chess, uci);
    if (!played) break;
    positions.push({ fen: played.fen, san: played.san, uci });
  }
  return positions;
}

export function positionKey(fen: string) { return fen.split(" ").slice(0, 4).join(" "); }
